import React from "react";
import { render } from "react-dom";
import ThemedApp from "./containers/ThemedApp";

// eslint-disable-next-line no-unused-vars
import styles from "./styles.css";

render(<ThemedApp />, document.getElementById("root"));
